import { useMutation } from "@tanstack/react-query";
import { resendVerifyUserEmail } from "../../apis/user";

type ResendVerifyEmailParams = {
  token: string;
  email: string;
};

export function useResendVerifyEmail() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ token, email }: ResendVerifyEmailParams) => {
      return resendVerifyUserEmail(email, token);
    },
  });

  return {
    resendVerifyUserEmail: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
